import type { ReactElement } from 'react';

/**
 * Enum of all available webform types.
 *
 * Makes it easier to read and edit the ids.
 */

export enum WEBFORM_ID {}

/**
 * Type definition for a webform component properties.
 */

export type WebformProps = {
  /**
   * A custom label for the submit button.
   */
  submitLabel?: string;

  /**
   * A custom label for the resource link after a successful submission.
   */
  resourceLabel?: string;

  /**
   * Boolean indicating if the form is rendered in a drawer.
   */
  inDrawer?: boolean;

  /**
   * A custom component to render instead of the default drawer header.
   */
  drawerHeader?: ReactElement;

  /**
   * A custom component to render instead of the default thank you message.
   */
  thankYou?: ReactElement;

  /**
   * A function to be called on successful form submission.
   */
  onSuccess?: () => void;
};

/**
 * Type definition for a webform component.
 */

export type Webform = (props: WebformProps) => ReactElement;

/**
 * Factory type for all webforms.
 *
 * It uses `string` instead of `WEBFORM_ID` as key so that each site can have its own webforms.
 */

export type WebformsFactory = Record<string, Webform>;

/**
 * Factory of all available webforms.
 */

export const webforms: WebformsFactory = {};
